export const routes = {
    home: "/",
    about: "/about"
}